module.exports = __webpack_public_path__ + "img/23_59.bf823e6d.png";